import React from 'react';
import { motion, AnimatePresence } from 'framer-motion';

const Navigation = ({ isMenuOpen, setIsMenuOpen, scrollToSection }) => {
  return (
    <>
      <nav className="nav" role="navigation" aria-label="Main navigation">
        <div className="nav-container">
          <button
            className="logo"
            onClick={() => scrollToSection('home')}
            aria-label="Go to homepage"
          >
            <img
              src={process.env.PUBLIC_URL + '/padraos-logo.png'}
              alt="Padraos Consulting"
              className="logo-image"
              loading="eager"
            />
          </button>
          <ul className="nav-links" role="menubar">
            <li role="none"><button role="menuitem" onClick={() => scrollToSection('home')}>Home</button></li>
            <li role="none"><button role="menuitem" onClick={() => scrollToSection('services')}>Services</button></li>
            <li role="none"><button role="menuitem" onClick={() => scrollToSection('case-studies')}>Case Studies</button></li>
            <li role="none"><button role="menuitem" onClick={() => scrollToSection('clients')}>Testimonials</button></li>
            <li role="none"><button role="menuitem" onClick={() => scrollToSection('careers')}>Careers</button></li>
            <li role="none"><button role="menuitem" onClick={() => scrollToSection('contact')}>Contact</button></li>
          </ul>
          <button
            className="mobile-menu-btn"
            onClick={() => setIsMenuOpen(!isMenuOpen)}
            aria-label={isMenuOpen ? "Close menu" : "Open menu"}
            aria-expanded={isMenuOpen}
            aria-controls="mobile-menu"
          >
            <span></span>
            <span></span>
            <span></span>
          </button>
        </div>
      </nav>

      {/* Mobile Menu */}
      <AnimatePresence>
        {isMenuOpen && (
          <>
            <motion.div
              className="mobile-menu-overlay"
              initial={{ opacity: 0 }}
              animate={{ opacity: 1 }}
              exit={{ opacity: 0 }}
              onClick={() => setIsMenuOpen(false)}
            />
            <motion.nav
              id="mobile-menu"
              className="mobile-menu"
              initial={{ x: '100%' }}
              animate={{ x: 0 }}
              exit={{ x: '100%' }}
              transition={{ type: 'tween', duration: 0.3 }}
              role="navigation"
              aria-label="Mobile navigation"
            >
              <button
                className="mobile-menu-close"
                onClick={() => setIsMenuOpen(false)}
                aria-label="Close menu"
              >
                ✕
              </button>
              <div className="mobile-menu-nav">
                <button onClick={() => scrollToSection('home')}>Home</button>
                <button onClick={() => scrollToSection('services')}>Services</button>
                <button onClick={() => scrollToSection('case-studies')}>Case Studies</button>
                <button onClick={() => scrollToSection('clients')}>Testimonials</button>
                <button onClick={() => scrollToSection('careers')}>Careers</button>
                <button onClick={() => scrollToSection('contact')}>Contact</button>
              </div>
            </motion.nav>
          </>
        )}
      </AnimatePresence>
    </>
  );
};

export default Navigation;
